module.exports = "# 数据驱动\n简而言之就是，改变页面不再去dom操作，而是去通过改变数据，（中间dom操作交给框架）来更新视图\n```\n// 页面全部通过数据来渲染\nconst data = {\n  title: '测试',\n  notice: '您正在使用mvvm强力驱动网站',\n  isLoading: false,\n};\n<head>{{ title }}</head>\n<div if=\"isLoading\">\n  {{ notice }}\n</div>\n<div if=\"!isLoading\">\n  页面加载中···\n</div>\n```\n渲染出来的结果是\n```\n<head>测试</head>\n<div>\n  页面加载中···\n</div>\n// 当页面加载完成后，只需要改变isLoading，就会自动更新为\ndata.isLoading = true;\n<head>测试</head>\n<div>\n  您正在使用mvvm强力驱动网站\n</div>\n```\n简单如斯\n\n## 为什么要使用数据驱动（mvvm\n~~人生苦短，我选mvvm~~\n当页面存在较多的数据渲染，而硬核（不可替代的）dom操作比较少时，可以考虑使用mvvm\n"


//////////////////
// WEBPACK FOOTER
// ./src/store/databind.md
// module id = 148
// module chunks = 2